module.exports = __webpack_public_path__ + "img/cloud-sun-rain.df1c73d2.svg";